module.exports = __webpack_public_path__ + "img/arrow.cadb5f0c.svg";